export const toErrorMessage = (
  value: any
): string => {
  if (value instanceof Error) {
    return value.message;
  }

  if (typeof value?.toString === 'function') {
    return value.toString();
  }

  return 'unknown';
};
